import styled from '@emotion/styled';
import CloseIcon from '../../../assets/icons/close.svg?react';
import {InputField} from "@toluna-ui-toolkit/inputs";
import {Modal as TModal} from '@toluna-ui-toolkit/modals';
import {SelectBox} from "@toluna-ui-toolkit/selectbox";
import {css} from "@emotion/react";
import React from "react";

export const CloseButton = styled(CloseIcon)`
    cursor: pointer;
    
    path {
        stroke: #000;
    }
`;

export const Modal = styled(TModal)``

export const ImportProjectWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 500;
`;

export const ImportProjectModalHeader = styled.div`
    background: #EEEBF3;
    padding: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const HeaderTitle = styled.span`
    font-size: 24px;
    line-height: 24px;
    font-weight: 600;
    font-family: GreycliffCF;
`

export const ImportProjectModalBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 25px;
`;

export const ImportProjectModalFooterErrorContainer = styled.div`
    padding: 0 25px 0;
    width: 100%;
    text-align: right;
    box-sizing: border-box;
    
    &:last-child {
        padding-bottom: 25px;
    }
`

export const ImportProjectModalFooter = styled.div`
    display: flex;
    flex-direction: row-reverse;
    padding: 25px;
`;

export const InputItem = styled.div<{ withMargin?: boolean }>`
    ${({ withMargin }) => withMargin && css`
        margin-top: 20px;
    `}
`;

export const InputContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`

export const Label = styled.span<{ isError?: boolean }>`
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    font-family: GreycliffCF;
    color: black;

    ${({ isError }) => isError && css`
        color: red;
        font-size: 12px;
    `}
`;

export const TextInput = styled(InputField)`
    height: 48px;
    font-size: 14px;
    line-height: 16.8px;
    box-shadow: unset;
    font-family: GreycliffCF;
    color: rgb(128, 128, 128);
    padding-right: 60px;
`

export const Icon = styled.i<{ enabled?: boolean }>`
    position: absolute;
    right: 20px;
    top: 50%;
    font-size: 20px;
    color: #cfd9db;
    cursor: pointer;
    transition: color 0.3s ease-in-out;
    transform: translateY(-50%);
    
    ${({ enabled }) => enabled && css`
        color: #00297A;
    `}
`;

export const DropDown = styled(SelectBox)``

export const Button = styled.button<{ buttonType?: 'outlined' | 'contained', disabled?: boolean, isLoading?: boolean }>`
    cursor: pointer;
    width: fit-content;
    padding: 10px 20px;
    border: 1px solid #00297A;
    background: #00297A;
    color: white;
    font-size: 14px;
    line-height: 16.8px;
    font-family: GreycliffCF;
    font-weight: 600;
    border-radius: 8px;
    min-height: 42px;
    min-width: 106px;
    margin-left: 20px;
    transition: all 1s ease;
    
    ${({ isLoading }) => isLoading && css`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `}
    
    ${({ disabled }) => disabled && css`
        border: 1px solid #d4d4d4;
        background: #d4d4d4;
    `}
    
    ${({ buttonType }) => buttonType === 'outlined' && css`
        background: unset;
        color: #00297A;
    `}
`;

export const ImportProjectModalContainer = styled.div`
    background-color: white;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
`;

export const ImportProjectAppWrapper = styled.div`
    width: 100%;
    height: 100%;
    min-height: 408px;
    max-width: 628px;
`;

export const modalCustomStyles = {
    width: '628px',
    overflow: 'unset'
}

export const dropdownCustomStyle = { control : { height: '48px'  }}

export const loaderCustomStyles = (isButtonLoader?: boolean) => {
    if(isButtonLoader) {
        return {
            width: '14px',
            height: '14px',
            marginLeft: '15px',
        } as React.CSSProperties
    }

    return {
        position: 'absolute',
        right: '20px',
        width: '20px',
        height: '20px'
    } as React.CSSProperties
}